// src/services/reportService.js
import api from './api';
import { downloadBlobFile } from './nativeFileService';

const reportService = {
  getOperationalReport: async (reportType, filters) => {
    const response = await api.get(`/reports/${reportType}`, { params: filters, timeout: 90000 });
    return response.data;
  },
  exportOperationalReport: async (reportType, filters, format) => {
    const response = await api.post(`/reports/export/${format}`, { reportType, filters }, { responseType: 'blob', timeout: 180000 });
    const pdf = format === 'pdf';
    await downloadBlobFile(response.data, {
      fileName: `reporte_${reportType}_${Date.now()}.${pdf ? 'pdf' : 'xlsx'}`,
      mimeType: pdf ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
  },
  // Obtener reportes
  getProjectsReport: async (filters) => {
    const response = await api.get('/reports/projects', { params: filters });
    return response.data;
  },

  getClientsReport: async (filters) => {
    const response = await api.get('/reports/clients', { params: filters });
    return response.data;
  },

  getTasksReport: async (filters) => {
    const response = await api.get('/reports/tasks', { params: filters });
    return response.data;
  },

  getFinancesReport: async (filters) => {
    const response = await api.get('/reports/finances', { params: filters });
    return response.data;
  },

  getUsersReport: async () => {
    const response = await api.get('/reports/users');
    return response.data;
  },

  // Exportar
  exportToPDF: async (reportType, data) => {
    const response = await api.post('/reports/export/pdf', { reportType, data }, {
      responseType: 'blob'
    });

    await downloadBlobFile(response.data, {
      fileName: `report_${reportType}_${Date.now()}.pdf`,
      mimeType: 'application/pdf'
    });
  },

  exportToExcel: async (reportType, data) => {
    const response = await api.post('/reports/export/excel', { reportType, data }, {
      responseType: 'blob'
    });

    await downloadBlobFile(response.data, {
      fileName: `report_${reportType}_${Date.now()}.xlsx`,
      mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
  }
};

export default reportService;
